import Cookie from 'js-cookie'

const getToken = () => {
  return Cookie.get(process.env.REACT_APP_TOKEN)
}

const getFarmData = () => {
  return Cookie.get(process.env.REACT_APP_WEB_FARM)
}

const clearStorage = () => {
  localStorage.clear()
  sessionStorage.clear()
}

const clearCookies = () => {
  Cookie.remove(process.env.REACT_APP_TOKEN)
  Cookie.remove(process.env.REACT_APP_WEB_FARM)
}

export {
  getToken,
  getFarmData,
  clearStorage,
  clearCookies
}
